import { v4 as uuid } from 'uuid';

import { sleep } from '~/api/mocks/utils';
import { CreditTransaction } from '~/features/billing/CreditBalance/types';

// TODO: Remove this endpoint as we will be updating credit endpoitn to get this data.
export const getCreditLedger = async (): Promise<{
  transactions: CreditTransaction[];
  totalCount: number;
}> => {
  const transactions = Array.from({ length: 10 }).map(() => ({
    credits: Math.round(Math.random() * 100),
    creditType: 'Added',
    createdBy: 'System',
    //l10n-ignore: API parsing no formatting required
    effectiveDate: new Date(),
    //l10n-ignore: API parsing no formatting required
    eventDate: new Date(),
    //l10n-ignore: API parsing no formatting required
    expirationDate: new Date(),
    id: uuid(),
    notes: 'Added credits',
    //l10n-ignore: API parsing no formatting required
    renewalDate: new Date(),
  }));

  await sleep(4000);

  return { transactions, totalCount: transactions.length };
};
